import axios from 'axios'
import { API_HOST } from 'consts'
import { SelectionProcessResult } from 'data/domain/selection-processes'

export const fetchSelectionProcessResults = () => {
  return axios
    .get<SelectionProcessResult[]>(`${API_HOST}/v1/user_result`)
    .then((response) => response.data)
}
